import React, { useState } from "react";
import SharedHelmet from "../../Helmet";
import { SecondAds } from "../../../Ads";
const TITLE = "حاسبة الجرعة اليومية للفيتامينات - احسب احتياجك من الفيتامينات";
const DESCRIPTION =
  "حاسبة الجرعة اليومية للفيتامينات الدقيقة لحساب احتياجك اليومي من الفيتامينات الأساسية بناءً على العمر والجنس. تشمل فيتامينات A, C, D, E, K وجميع فيتامينات B المركب مع شرح مفصل لفوائد كل فيتامين ومصادره الطبيعية.";
const KEYWORDS =
  "حاسبة الفيتامينات, الجرعة اليومية للفيتامينات, احتياج الجسم من الفيتامينات, فيتامين A, فيتامين C, فيتامين D, فيتامين E, فيتامين K, فيتامين B المركب, الثيامين B1, الريبوفلافين B2, النياسين B3, حمض الفوليك, فيتامين B12, مصادر الفيتامينات, نقص الفيتامينات";
const OG_URL = "https://do-calculate.com/calculator/ar/vitamin_daily_dose/";
const vitaminsList = {
  A: "فيتامين A",
  C: "فيتامين C",
  D: "فيتامين D",
  E: "فيتامين E",
  K: "فيتامين K",
  B1: "الثيامين (B1)",
  B2: "الريبوفلافين (B2)",
  B3: "النياسين (B3)",
  B6: "البيريدوكسين (B6)",
  B9: "حمض الفوليك (B9)",
  B12: "الكوبالامين (B12)",
  B5: "حمض البانتوتينيك (B5)",
  B7: "البيوتين (B7)",
  Choline: "الكولين",
};
const vitaminUnits = {
  A: "ميكروغرام",
  C: "ملغ",
  D: "ميكروغرام",
  E: "ملغ",
  K: "ميكروغرام",
  B1: "ملغ",
  B2: "ملغ",
  B3: "ملغ",
  B6: "ملغ",
  B9: "ميكروغرام",
  B12: "ميكروغرام",
  B5: "ملغ",
  B7: "ميكروغرام",
  Choline: "ملغ",
};
const VitaminDailyDoseCalculator = () => {
  const [selectedVitamin, setSelectedVitamin] = useState("A");
  const [age, setAge] = useState("");
  const [sex, setSex] = useState("male");
  const [isPregnant, setIsPregnant] = useState(false);
  const [isLactating, setIsLactating] = useState(false);
  const [dose, setDose] = useState(null);
  const [error, setError] = useState("");
  // Vitamin dosage data based on age and sex (in micrograms or mg)
  const getVitaminDose = (vitamin, ageValue, gender, pregnant, lactating) => {
    const dosageTable = {
      A: {
        // Retinol Activity Equivalents (RAE) in micrograms
        male: {
          "0-6m": 400,
          "7-12m": 500,
          "1-3y": 300,
          "4-8y": 400,
          "9-13y": 600,
          "14-18y": 900,
          "19-50y": 900,
          "51+y": 900,
        },
        female: {
          "0-6m": 400,
          "7-12m": 500,
          "1-3y": 300,
          "4-8y": 400,
          "9-13y": 600,
          "14-18y": 700,
          "19-50y": 700,
          "51+y": 700,
        },
        pregnant: 770,
        lactating: 1300,
      },
      C: {
        // Vitamin C in mg
        male: {
          "0-6m": 40,
          "7-12m": 50,
          "1-3y": 15,
          "4-8y": 25,
          "9-13y": 45,
          "14-18y": 75,
          "19-50y": 90,
          "51+y": 90,
        },
        female: {
          "0-6m": 40,
          "7-12m": 50,
          "1-3y": 15,
          "4-8y": 25,
          "9-13y": 45,
          "14-18y": 65,
          "19-50y": 75,
          "51+y": 75,
        },
        pregnant: 85,
        lactating: 120,
      },
      D: {
        // Vitamin D in micrograms
        male: {
          "0-6m": 10,
          "7-12m": 10,
          "1-3y": 15,
          "4-8y": 15,
          "9-13y": 15,
          "14-18y": 15,
          "19-50y": 15,
          "51-70y": 15,
          "71+y": 20,
        },
        female: {
          "0-6m": 10,
          "7-12m": 10,
          "1-3y": 15,
          "4-8y": 15,
          "9-13y": 15,
          "14-18y": 15,
          "19-50y": 15,
          "51-70y": 15,
          "71+y": 20,
        },
        pregnant: 15,
        lactating: 15,
      },
      E: {
        // Vitamin E in mg
        male: {
          "0-6m": 4,
          "7-12m": 5,
          "1-3y": 6,
          "4-8y": 7,
          "9-13y": 11,
          "14-18y": 15,
          "19-50y": 15,
          "51+y": 15,
        },
        female: {
          "0-6m": 4,
          "7-12m": 5,
          "1-3y": 6,
          "4-8y": 7,
          "9-13y": 11,
          "14-18y": 15,
          "19-50y": 15,
          "51+y": 15,
        },
        pregnant: 15,
        lactating: 19,
      },
      K: {
        // Vitamin K in micrograms
        male: {
          "0-6m": 2,
          "7-12m": 2.5,
          "1-3y": 30,
          "4-8y": 55,
          "9-13y": 60,
          "14-18y": 75,
          "19-50y": 120,
          "51+y": 120,
        },
        female: {
          "0-6m": 2,
          "7-12m": 2.5,
          "1-3y": 30,
          "4-8y": 55,
          "9-13y": 60,
          "14-18y": 75,
          "19-50y": 90,
          "51+y": 90,
        },
        pregnant: 90,
        lactating: 90,
      },
      B1: {
        // Thiamin in mg
        male: {
          "0-6m": 0.2,
          "7-12m": 0.3,
          "1-3y": 0.5,
          "4-8y": 0.6,
          "9-13y": 0.9,
          "14-18y": 1.2,
          "19-50y": 1.2,
          "51+y": 1.2,
        },
        female: {
          "0-6m": 0.2,
          "7-12m": 0.3,
          "1-3y": 0.5,
          "4-8y": 0.6,
          "9-13y": 0.9,
          "14-18y": 1.0,
          "19-50y": 1.1,
          "51+y": 1.1,
        },
        pregnant: 1.4,
        lactating: 1.4,
      },
      B2: {
        // Riboflavin in mg
        male: {
          "0-6m": 0.3,
          "7-12m": 0.4,
          "1-3y": 0.5,
          "4-8y": 0.6,
          "9-13y": 0.9,
          "14-18y": 1.3,
          "19-50y": 1.3,
          "51+y": 1.3,
        },
        female: {
          "0-6m": 0.3,
          "7-12m": 0.4,
          "1-3y": 0.5,
          "4-8y": 0.6,
          "9-13y": 0.9,
          "14-18y": 1.0,
          "19-50y": 1.1,
          "51+y": 1.1,
        },
        pregnant: 1.4,
        lactating: 1.6,
      },
      B3: {
        // Niacin in mg
        male: {
          "0-6m": 2,
          "7-12m": 4,
          "1-3y": 6,
          "4-8y": 8,
          "9-13y": 12,
          "14-18y": 16,
          "19-50y": 16,
          "51+y": 16,
        },
        female: {
          "0-6m": 2,
          "7-12m": 4,
          "1-3y": 6,
          "4-8y": 8,
          "9-13y": 12,
          "14-18y": 14,
          "19-50y": 14,
          "51+y": 14,
        },
        pregnant: 18,
        lactating: 17,
      },
      B6: {
        // Pyridoxine in mg
        male: {
          "0-6m": 0.1,
          "7-12m": 0.3,
          "1-3y": 0.5,
          "4-8y": 0.6,
          "9-13y": 1.0,
          "14-18y": 1.3,
          "19-50y": 1.3,
          "51-70y": 1.7,
          "71+y": 1.7,
        },
        female: {
          "0-6m": 0.1,
          "7-12m": 0.3,
          "1-3y": 0.5,
          "4-8y": 0.6,
          "9-13y": 1.0,
          "14-18y": 1.2,
          "19-50y": 1.3,
          "51-70y": 1.5,
          "71+y": 1.5,
        },
        pregnant: 1.9,
        lactating: 2.0,
      },
      B9: {
        // Folate in micrograms
        male: {
          "0-6m": 65,
          "7-12m": 80,
          "1-3y": 150,
          "4-8y": 200,
          "9-13y": 300,
          "14-18y": 400,
          "19-50y": 400,
          "51+y": 400,
        },
        female: {
          "0-6m": 65,
          "7-12m": 80,
          "1-3y": 150,
          "4-8y": 200,
          "9-13y": 300,
          "14-18y": 400,
          "19-50y": 400,
          "51+y": 400,
        },
        pregnant: 600,
        lactating: 500,
      },
      B12: {
        // Cobalamin in micrograms
        male: {
          "0-6m": 0.4,
          "7-12m": 0.5,
          "1-3y": 0.9,
          "4-8y": 1.2,
          "9-13y": 1.8,
          "14-18y": 2.4,
          "19-50y": 2.4,
          "51+y": 2.4,
        },
        female: {
          "0-6m": 0.4,
          "7-12m": 0.5,
          "1-3y": 0.9,
          "4-8y": 1.2,
          "9-13y": 1.8,
          "14-18y": 2.4,
          "19-50y": 2.4,
          "51+y": 2.4,
        },
        pregnant: 2.6,
        lactating: 2.8,
      },
      B5: {
        // Pantothenic Acid in mg
        male: {
          "0-6m": 1.7,
          "7-12m": 1.8,
          "1-3y": 2,
          "4-8y": 3,
          "9-13y": 4,
          "14-18y": 5,
          "19-50y": 5,
          "51+y": 5,
        },
        female: {
          "0-6m": 1.7,
          "7-12m": 1.8,
          "1-3y": 2,
          "4-8y": 3,
          "9-13y": 4,
          "14-18y": 5,
          "19-50y": 5,
          "51+y": 5,
        },
        pregnant: 6,
        lactating: 7,
      },
      B7: {
        // Biotin in micrograms
        male: {
          "0-6m": 5,
          "7-12m": 6,
          "1-3y": 8,
          "4-8y": 12,
          "9-13y": 20,
          "14-18y": 25,
          "19-50y": 30,
          "51+y": 30,
        },
        female: {
          "0-6m": 5,
          "7-12m": 6,
          "1-3y": 8,
          "4-8y": 12,
          "9-13y": 20,
          "14-18y": 25,
          "19-50y": 30,
          "51+y": 30,
        },
        pregnant: 30,
        lactating: 35,
      },
      Choline: {
        // Choline in mg
        male: {
          "0-6m": 125,
          "7-12m": 150,
          "1-3y": 200,
          "4-8y": 250,
          "9-13y": 375,
          "14-18y": 550,
          "19-50y": 550,
          "51+y": 550,
        },
        female: {
          "0-6m": 125,
          "7-12m": 150,
          "1-3y": 200,
          "4-8y": 250,
          "9-13y": 375,
          "14-18y": 400,
          "19-50y": 425,
          "51+y": 425,
        },
        pregnant: 450,
        lactating: 550,
      },
    };
    // Determine age category
    let ageCategory;
    const ageNum = parseInt(ageValue);
    if (ageNum < 1) {
      if (ageNum < 0.5) ageCategory = "0-6m";
      else ageCategory = "7-12m";
    } else if (ageNum >= 1 && ageNum <= 3) {
      ageCategory = "1-3y";
    } else if (ageNum >= 4 && ageNum <= 8) {
      ageCategory = "4-8y";
    } else if (ageNum >= 9 && ageNum <= 13) {
      ageCategory = "9-13y";
    } else if (ageNum >= 14 && ageNum <= 18) {
      ageCategory = "14-18y";
    } else if (ageNum >= 19 && ageNum <= 50) {
      ageCategory = "19-50y";
    } else if (ageNum >= 51 && ageNum <= 70) {
      ageCategory = "51-70y" in dosageTable[vitamin][gender]
        ? "51-70y"
        : "51+y";
    } else {
      ageCategory = "71+y" in dosageTable[vitamin][gender]
        ? "71+y"
        : "51+y";
    }
    // Check for pregnancy or lactation
    if (gender === "female" && pregnant) {
      return dosageTable[vitamin].pregnant;
    }
    if (gender === "female" && lactating) {
      return dosageTable[vitamin].lactating;
    }
    return dosageTable[vitamin][gender][ageCategory];
  };
  const calculateDailyDose = () => {
    try {
      if (!age || age < 0 || age > 120) {
        setError("الرجاء إدخال عمر صحيح (0-120 سنة)");
        setDose(null);
        return;
      }
      const calculatedDose = getVitaminDose(
        selectedVitamin,
        age,
        sex,
        isPregnant,
        isLactating
      );
      setDose(calculatedDose);
      setError("");
    } catch (error) {
      setDose(null);
      setError("حدث خطأ في حساب الجرعة. الرجاء التحقق من البيانات المدخلة.");
    }
  };
  const handleCalculate = (e) => {
    e.preventDefault();
    calculateDailyDose();
  };
  const handleReset = () => {
    setSelectedVitamin("A");
    setAge("");
    setSex("male");
    setIsPregnant(false);
    setIsLactating(false);
    setDose(null);
    setError("");
  };
  // Generate Schema.org structured data
  const generateSchemaData = () => {
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "الصفحة الرئيسية",
          item: "https://do-calculate.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "الحاسبات",
          item: "https://do-calculate.com/ar/all-calculators/",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "حاسبة الفيتامينات",
          item: OG_URL,
        },
      ],
    };
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "كيف أحسب احتياجي اليومي من الفيتامينات؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "لحساب احتياجك اليومي من الفيتامينات، أدخل عمرك واختر الجنس والفيتامين المطلوب في حاسبة الفيتامينات. الاحتياجات تختلف حسب العمر والجنس والحالة الصحية.",
          },
        },
        {
          "@type": "Question",
          name: "ما هي أهم الفيتامينات للجسم؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "أهم الفيتامينات تشمل: فيتامين D للعظام، فيتامين C للمناعة، فيتامين A للبصر، فيتامين B12 للأعصاب، وحمض الفوليك خاصة للحوامل.",
          },
        },
        {
          "@type": "Question",
          name: "ما هي أعراض نقص الفيتامينات؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "أعراض نقص الفيتامينات تشمل: التعب والإرهاق، ضعف المناعة، مشاكل الجلد، ضعف العظام، فقر الدم، ومشاكل الأعصاب حسب نوع الفيتامين الناقص.",
          },
        },
      ],
    };
    const calculatorSchema = {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      name: "حاسبة الجرعة اليومية للفيتامينات",
      description: DESCRIPTION,
      url: OG_URL,
      applicationCategory: "HealthApplication",
      operatingSystem: "Any",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
    };
    return [breadcrumbSchema, faqSchema, calculatorSchema];
  };
  return (
    <div className="rtl" style={{ direction: "rtl" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={generateSchemaData()}
      />
      <div>
        <br />
        <div
          className="bg-success text-white text-center"
          style={{ padding: "15px", borderRadius: "12px" }}
        >
          <h1 style={{ fontSize: "22px", margin: 0 }}>{TITLE}</h1>
        </div>
        <div className="border border-light mt-3 p-3 bg-white shadow-sm">
          <div className="mb-4">
            <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
              <strong>حاسبة الجرعة اليومية للفيتامينات</strong> تساعدك على معرفة
              احتياجك اليومي من الفيتامينات الأساسية بناءً على عمرك وجنسك
              وحالتك الصحية. تشمل الحاسبة جميع الفيتامينات الضرورية بما في ذلك
              فيتامينات <strong>A, C, D, E, K</strong> وجميع فيتامينات{" "}
              <strong>B المركب</strong> مع معلومات مفصلة عن فوائد ومصادر كل
              فيتامين.
            </p>
          </div>
          <hr />
          <div className="row">
           <div className="col-sm-12 col-md-6 calculatorStyle">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>
                  احسب احتياجك اليومي
                </h2>
              </div>
              <form onSubmit={handleCalculate}>
                <div className="form-group mb-3">
                  <label  htmlFor="vitamin">
                    <strong>اختر الفيتامين:</strong>
                  </label>
                  <select
                    className="form-control"
                    id="vitamin"
                    value={selectedVitamin}
                    onChange={(e) => setSelectedVitamin(e.target.value)}
                  >
                    {Object.keys(vitaminsList).map((key) => (
                      <option key={key} value={key}>
                        {vitaminsList[key]}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group mb-3">
                  <label  htmlFor="age">
                    <strong>العمر (بالسنوات):</strong>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="age"
                    value={age}
                    onChange={(e) => setAge(e.target.value)}
                    placeholder="أدخل عمرك"
                    min="0"
                    max="120"
                    required
                  />
                </div>
                <div className="form-group mb-3">
                  <label  htmlFor="sex">
                    <strong>الجنس:</strong>
                  </label>
                  <select
                    className="form-control"
                    id="sex"
                    value={sex}
                    onChange={(e) => {
                      setSex(e.target.value);
                      if (e.target.value === "male") {
                        setIsPregnant(false);
                        setIsLactating(false);
                      }
                    }}
                  >
                    <option value="male">ذكر</option>
                    <option value="female">أنثى</option>
                  </select>
                </div>
                {sex === "female" && (
                  <>
                    <div className="form-group mb-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="pregnant"
                          checked={isPregnant}
                          onChange={(e) => {
                            setIsPregnant(e.target.checked);
                            if (e.target.checked) setIsLactating(false);
                          }}
                        />
                        <label className="form-check-label" htmlFor="pregnant">
                          حامل
                        </label>
                      </div>
                    </div>
                    <div className="form-group mb-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="lactating"
                          checked={isLactating}
                          onChange={(e) => {
                            setIsLactating(e.target.checked);
                            if (e.target.checked) setIsPregnant(false);
                          }}
                        />
                        <label className="form-check-label" htmlFor="lactating">
                          مرضعة
                        </label>
                      </div>
                    </div>
                  </>
                )}
                <hr />
                <div className="d-flex gap-2">
                  <button
                    type="submit"
                    className="btn bg-success text-white"
                    style={{ fontSize: "16px", padding: "10px 30px" }}
                  >
                    احسب
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleReset}
                    style={{ fontSize: "16px", padding: "10px 30px" }}
                  >
                    امسح
                  </button>
                </div>
              </form>
            </div>
            <div className="col-sm-12 col-md-4">
              {error && (
                <div className="alert alert-warning" role="alert">
                  <strong>خطأ:</strong> {error}
                </div>
              )}
              {dose !== null && !error && (
                <div className="calculatorStyle">
                  <div className="p-3 mb-3 bg-success text-white text-center rounded">
                    <h3 style={{ fontSize: "18px", margin: 0 }}>النتيجة</h3>
                  </div>
                  <div
                    className="alert alert-success"
                    style={{ fontSize: "16px", lineHeight: "1.8" }}
                  >
                    <h4 style={{ fontSize: "17px", marginBottom: "15px" }}>
                      الجرعة اليومية الموصى بها:
                    </h4>
                    <div
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        backgroundColor: "#d4edda",
                        borderRadius: "8px",
                        marginBottom: "15px",
                      }}
                    >
                      <div style={{ fontSize: "18px", marginBottom: "10px" }}>
                        <strong>{vitaminsList[selectedVitamin]}</strong>
                      </div>
                      <div
                        style={{
                          fontSize: "32px",
                          fontWeight: "bold",
                          color: "#155724",
                        }}
                      >
                        {dose} {vitaminUnits[selectedVitamin]}
                      </div>
                    </div>
                    <div style={{ fontSize: "14px", marginTop: "15px" }}>
                      <strong>ملاحظة:</strong>
                      <ul style={{ marginTop: "10px", lineHeight: "1.6" }}>
                        <li>
                          هذه الجرعة تمثل الكمية اليومية الموصى بها (RDA)
                        </li>
                        <li>
                          احتياجاتك الفعلية قد تختلف حسب حالتك الصحية ونظامك
                          الغذائي
                        </li>
                        <li>استشر طبيبك قبل تناول أي مكملات غذائية</li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
              <SecondAds />
            </div>
          </div>
          <hr />
          <div
            className="alert alert-info"
            style={{ fontSize: "15px", lineHeight: "1.8" }}
          >
            <strong>💡 معلومة مهمة:</strong> النتائج تعتمد على التوصيات
            الغذائية المرجعية (DRI) من المعاهد الوطنية للصحة الأمريكية. قد
            تحتاج لجرعات أعلى في حالات معينة بناءً على استشارة الطبيب.
          </div>
        </div>
        <br />
        {/* Vitamins Table */}
        <div className="border border-light p-3 bg-white shadow-sm">
          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
            احسب الجرعة اليومية لكل فيتامين
          </h2>
          <table className="table table-bordered table-hover">
            <thead>
              <tr style={{ backgroundColor: "#e7f3fe" }}>
                <th style={{ textAlign: "center", padding: "12px" }}>
                  اسم الفيتامين
                </th>
                <th style={{ textAlign: "center", padding: "12px" }}>
                  احسب الجرعة اليومية
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: "10px" }}>فيتامين A</td>
                <td style={{ padding: "10px" }}>
                  <a href="/calculator/ar/vitamin_daily_dose/a/">
                    احسب الجرعة اليومية لفيتامين A
                  </a>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>فيتامين C</td>
                <td style={{ padding: "10px" }}>
                  <a href="/calculator/ar/vitamin_daily_dose/c/">
                    احسب الجرعة اليومية لفيتامين C
                  </a>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>فيتامين D</td>
                <td style={{ padding: "10px" }}>
                  <a href="/calculator/ar/vitamin_daily_dose/d/">
                    احسب الجرعة اليومية لفيتامين D
                  </a>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>فيتامين E</td>
                <td style={{ padding: "10px" }}>
                  <a href="/calculator/ar/vitamin_daily_dose/e/">
                    احسب الجرعة اليومية لفيتامين E
                  </a>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>فيتامين K</td>
                <td style={{ padding: "10px" }}>
                  <a href="/calculator/ar/vitamin_daily_dose/k/">
                    احسب الجرعة اليومية لفيتامين K
                  </a>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>الثيامين (B1)</td>
                <td style={{ padding: "10px" }}>
                  <a href="/calculator/ar/vitamin_daily_dose/b1/">
                    احسب الجرعة اليومية لفيتامين الثيامين (B1)
                  </a>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>الريبوفلافين (B2)</td>
                <td style={{ padding: "10px" }}>
                  <a href="/calculator/ar/vitamin_daily_dose/b2/">
                    احسب الجرعة اليومية لفيتامين الريبوفلافين (B2)
                  </a>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>النياسين (B3)</td>
                <td style={{ padding: "10px" }}>
                  <a href="/calculator/ar/vitamin_daily_dose/b3/">
                    احسب الجرعة اليومية لفيتامين النياسين (B3)
                  </a>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>حمض البانتوتينيك (B5)</td>
                <td style={{ padding: "10px" }}>
                  <a href="/calculator/ar/vitamin_daily_dose/b5/">
                    احسب الجرعة اليومية لفيتامين حمض البانتوتينيك (B5)
                  </a>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>البيريدوكسين (B6)</td>
                <td style={{ padding: "10px" }}>
                  <a href="/calculator/ar/vitamin_daily_dose/b6/">
                    احسب الجرعة اليومية لفيتامين البيريدوكسين (B6)
                  </a>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>البيوتين (B7)</td>
                <td style={{ padding: "10px" }}>
                  <a href="/calculator/ar/vitamin_daily_dose/b7/">
                    احسب الجرعة اليومية لفيتامين البيوتين (B7)
                  </a>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>حمض الفوليك (B9)</td>
                <td style={{ padding: "10px" }}>
                  <a href="/calculator/ar/vitamin_daily_dose/b9/">
                    احسب الجرعة اليومية لفيتامين حمض الفوليك (B9)
                  </a>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>الكوبالامين (B12)</td>
                <td style={{ padding: "10px" }}>
                  <a href="/calculator/ar/vitamin_daily_dose/b12/">
                    احسب الجرعة اليومية لفيتامين الكوبالامين (B12)
                  </a>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>الكولين</td>
                <td style={{ padding: "10px" }}>
                  <a href="/calculator/ar/vitamin_daily_dose/choline/">
                    احسب الجرعة اليومية لـ الكولين
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        {/* Educational Content */}
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="info-sections-container">
              <div className="info-section">
                <div className="info-section-header">
                  <strong>دليل شامل للفيتامينات الأساسية</strong>
                </div>
                <div className="info-section-body">
                  <p style={{ lineHeight: "1.8" }}>
                    <strong>الفيتامينات</strong> هي مركبات عضوية ضرورية يحتاجها
                    الجسم بكميات صغيرة للنمو السليم والحفاظ على الصحة. معظم
                    الفيتامينات لا يستطيع الجسم إنتاجها، لذا يجب الحصول عليها من
                    الغذاء أو المكملات.
                  </p>
                  <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                    تصنيف الفيتامينات:
                  </h3>
                  <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                    <strong>1. الفيتامينات القابلة للذوبان في الدهون:</strong>
                  </h4>
                  <div
                    className="alert alert-info"
                    style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
                  >
                    <ul style={{ marginTop: "10px" }}>
                      <li>
                        <strong>فيتامين A:</strong> يخزن في الكبد، مهم للبصر
                        والمناعة
                      </li>
                      <li>
                        <strong>فيتامين D:</strong> ينتجه الجسم عند التعرض للشمس،
                        ضروري للعظام
                      </li>
                      <li>
                        <strong>فيتامين E:</strong> مضاد أكسدة قوي، يحمي الخلايا
                      </li>
                      <li>
                        <strong>فيتامين K:</strong> ضروري لتخثر الدم وصحة العظام
                      </li>
                    </ul>
                    <br />
                    <strong>ملاحظة:</strong> هذه الفيتامينات تُخزن في الجسم، لذا
                    الإفراط فيها قد يسبب مشاكل صحية.
                  </div>
                  <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                    <strong>2. الفيتامينات القابلة للذوبان في الماء:</strong>
                  </h4>
                  <div
                    className="alert alert-success"
                    style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                  >
                    <ul style={{ marginTop: "10px" }}>
                      <li>
                        <strong>فيتامين C:</strong> مضاد أكسدة، يقوي المناعة،
                        يساعد على امتصاص الحديد
                      </li>
                      <li>
                        <strong>فيتامينات B المركب (8 أنواع):</strong> ضرورية
                        لإنتاج الطاقة والأعصاب
                      </li>
                    </ul>
                    <br />
                    <strong>ملاحظة:</strong> لا تُخزن في الجسم، لذا يجب تناولها
                    يومياً.
                  </div>
                  <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                    أهمية الفيتامينات:
                  </h3>
                  <ol style={{ lineHeight: "1.8" }}>
                    <li>
                      <strong>إنتاج الطاقة:</strong> فيتامينات B تساعد في تحويل
                      الطعام إلى طاقة
                    </li>
                    <li>
                      <strong>تقوية المناعة:</strong> فيتامينات C, D, A تحمي من
                      الأمراض
                    </li>
                    <li>
                      <strong>صحة العظام:</strong> فيتامينات D, K, C ضرورية لعظام
                      قوية
                    </li>
                    <li>
                      <strong>صحة الجلد:</strong> فيتامينات A, C, E تحافظ على نضارة
                      البشرة
                    </li>
                    <li>
                      <strong>الوقاية من الأمراض المزمنة:</strong> مضادات الأكسدة
                      تحمي من السرطان وأمراض القلب
                    </li>
                  </ol>
                  <div
                    className="alert alert-warning mt-3"
                    style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}
                  >
                    <strong>⚠️ تنبيه:</strong> رغم أهمية الفيتامينات، فإن الإفراط
                    في تناولها قد يكون ضاراً. التزم بالجرعات الموصى بها واستشر
                    الطبيب قبل تناول أي مكملات.
                  </div>
                </div>
              </div>
              <div className="info-section">
                <div className="info-section-header">
                  <strong>مصادر الفيتامينات الطبيعية</strong>
                </div>
                <div className="info-section-body">
                  <p style={{ lineHeight: "1.8" }}>
                    أفضل طريقة للحصول على الفيتامينات هي من خلال{" "}
                    <strong>نظام غذائي متوازن ومتنوع</strong>. إليك أهم المصادر
                    الطبيعية لكل فيتامين:
                  </p>
                  <div
                    style={{
                      lineHeight: "1.8",
                      marginTop: "15px",
                      padding: "15px",
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                    }}
                  >
                    <h4 style={{ fontSize: "16px", color: "#198754" }}>
                      <strong>فيتامين A:</strong>
                    </h4>
                    <ul>
                      <li>الجزر، البطاطا الحلوة، اليقطين</li>
                      <li>السبانخ، الكرنب، البروكلي</li>
                      <li>الكبد، البيض، الحليب</li>
                      <li>المانجو، المشمش، الشمام</li>
                    </ul>
                  </div>
                  <div
                    style={{
                      lineHeight: "1.8",
                      marginTop: "15px",
                      padding: "15px",
                      backgroundColor: "#fff3cd",
                      borderRadius: "8px",
                    }}
                  >
                    <h4 style={{ fontSize: "16px", color: "#856404" }}>
                      <strong>فيتامين C:</strong>
                    </h4>
                    <ul>
                      <li>الحمضيات (برتقال، ليمون، جريب فروت)</li>
                      <li>الفلفل الحلو (الملون)</li>
                      <li>الفراولة، الكيوي، الجوافة</li>
                      <li>البروكلي، الطماطم</li>
                    </ul>
                  </div>
                  <div
                    style={{
                      lineHeight: "1.8",
                      marginTop: "15px",
                      padding: "15px",
                      backgroundColor: "#d1ecf1",
                      borderRadius: "8px",
                    }}
                  >
                    <h4 style={{ fontSize: "16px", color: "#0c5460" }}>
                      <strong>فيتامين D:</strong>
                    </h4>
                    <ul>
                      <li>
                        <strong>أشعة الشمس:</strong> 10-30 دقيقة يومياً (أهم مصدر)
                      </li>
                      <li>الأسماك الدهنية (سلمون، تونة، سردين)</li>
                      <li>صفار البيض</li>
                      <li>الحليب والأطعمة المدعمة بفيتامين D</li>
                    </ul>
                  </div>
                  <div
                    style={{
                      lineHeight: "1.8",
                      marginTop: "15px",
                      padding: "15px",
                      backgroundColor: "#d4edda",
                      borderRadius: "8px",
                    }}
                  >
                    <h4 style={{ fontSize: "16px", color: "#155724" }}>
                      <strong>فيتامين E:</strong>
                    </h4>
                    <ul>
                      <li>المكسرات (لوز، بندق، فول سوداني)</li>
                      <li>البذور (عباد الشمس، اليقطين)</li>
                      <li>الزيوت النباتية (زيت الزيتون، زيت عباد الشمس)</li>
                      <li>السبانخ، البروكلي، الأفوكادو</li>
                    </ul>
                  </div>
                  <div
                    style={{
                      lineHeight: "1.8",
                      marginTop: "15px",
                      padding: "15px",
                      backgroundColor: "#f8d7da",
                      borderRadius: "8px",
                    }}
                  >
                    <h4 style={{ fontSize: "16px", color: "#721c24" }}>
                      <strong>فيتامينات B المركب:</strong>
                    </h4>
                    <ul>
                      <li>
                        <strong>B1, B2, B3:</strong> الحبوب الكاملة، اللحوم،
                        البقوليات
                      </li>
                      <li>
                        <strong>B6:</strong> الدجاج، السمك، البطاطا، الموز
                      </li>
                      <li>
                        <strong>B9 (حمض الفوليك):</strong> الخضروات الورقية،
                        الحمضيات، البقوليات
                      </li>
                      <li>
                        <strong>B12:</strong> اللحوم، الأسماك، البيض، منتجات
                        الألبان
                      </li>
                    </ul>
                  </div>
                  <div
                    className="alert alert-info mt-3"
                    style={{ lineHeight: "1.8" }}
                  >
                    <strong>💡 نصيحة ذهبية:</strong> تناول "قوس قزح من الأطعمة" -
                    أي تناول أطعمة بألوان مختلفة يومياً يضمن حصولك على مجموعة
                    متنوعة من الفيتامينات والمعادن.
                  </div>
                </div>
              </div>
              <div className="info-section">
                <div className="info-section-header">
                  <strong>أعراض نقص الفيتامينات وعلاجها</strong>
                </div>
                <div className="info-section-body">
                  <p style={{ lineHeight: "1.8" }}>
                    <strong>نقص الفيتامينات</strong> يمكن أن يؤدي إلى مشاكل
                    صحية متعددة. إليك الأعراض الشائعة وطرق العلاج:
                  </p>
                  <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                    أعراض نقص الفيتامينات الشائعة:
                  </h3>
                  <div
                    className="alert alert-warning"
                    style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}
                  >
                    <strong>نقص فيتامين D:</strong>
                    <ul style={{ marginTop: "10px" }}>
                      <li>آلام وضعف العظام والعضلات</li>
                      <li>التعب والإرهاق المستمر</li>
                      <li>ضعف المناعة والإصابة المتكررة بالعدوى</li>
                      <li>تقلب المزاج والاكتئاب</li>
                      <li>بطء التئام الجروح</li>
                    </ul>
                    <br />
                    <strong>العلاج:</strong> التعرض للشمس، تناول الأسماك الدهنية،
                    مكملات فيتامين D
                  </div>
                  <div
                    className="alert alert-danger"
                    style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
                  >
                    <strong>نقص فيتامين B12:</strong>
                    <ul style={{ marginTop: "10px" }}>
                      <li>فقر الدم (شحوب، تعب، ضيق تنفس)</li>
                      <li>وخز وخدر في اليدين والقدمين</li>
                      <li>صعوبة في التوازن والمشي</li>
                      <li>مشاكل في الذاكرة والتركيز</li>
                      <li>التهاب اللسان واحمراره</li>
                    </ul>
                    <br />
                    <strong>العلاج:</strong> اللحوم، الأسماك، البيض، مكملات B12
                    (خاصة للنباتيين)
                  </div>
                  <div
                    className="alert alert-info"
                    style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
                  >
                    <strong>نقص فيتامين C:</strong>
                    <ul style={{ marginTop: "10px" }}>
                      <li>نزيف اللثة وتورمها</li>
                      <li>بطء التئام الجروح</li>
                      <li>جفاف الجلد وتقشره</li>
                      <li>ضعف المناعة</li>
                      <li>آلام المفاصل</li>
                    </ul>
                    <br />
                    <strong>العلاج:</strong> الحمضيات، الفلفل الملون، الفراولة،
                    البروكلي
                  </div>
                  <div
                    className="alert alert-success"
                    style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                  >
                    <strong>نقص حمض الفوليك (B9):</strong>
                    <ul style={{ marginTop: "10px" }}>
                      <li>فقر الدم الضخم الأرومات</li>
                      <li>التعب والضعف</li>
                      <li>تقرحات الفم واللسان</li>
                      <li>شيب الشعر المبكر</li>
                      <li>
                        <strong>خطير جداً للحوامل:</strong> تشوهات الجنين
                      </li>
                    </ul>
                    <br />
                    <strong>العلاج:</strong> الخضروات الورقية، البقوليات،
                    الحمضيات، مكملات حمض الفوليك
                  </div>
                  <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                    الفئات الأكثر عرضة لنقص الفيتامينات:
                  </h3>
                  <ul style={{ lineHeight: "1.8" }}>
                    <li>
                      <strong>النباتيون:</strong> معرضون لنقص B12, D, الحديد،
                      الزنك
                    </li>
                    <li>
                      <strong>كبار السن:</strong> معرضون لنقص D, B12, الكالسيوم
                    </li>
                    <li>
                      <strong>الحوامل والمرضعات:</strong> يحتجن جرعات أعلى من
                      حمض الفوليك والحديد
                    </li>
                    <li>
                      <strong>الأشخاص الذين لا يتعرضون للشمس:</strong> معرضون
                      لنقص فيتامين D
                    </li>
                    <li>
                      <strong>مرضى الأمعاء:</strong> معرضون لنقص جميع
                      الفيتامينات بسبب سوء الامتصاص
                    </li>
                  </ul>
                  <div
                    className="alert alert-danger mt-3"
                    style={{ lineHeight: "1.8" }}
                  >
                    <strong>⚠️ متى تزور الطبيب؟</strong>
                    <ul style={{ marginTop: "10px" }}>
                      <li>إذا كنت تعاني من أعراض مستمرة لنقص الفيتامينات</li>
                      <li>قبل تناول أي مكملات غذائية</li>
                      <li>إذا كنت حاملاً أو تخططين للحمل</li>
                      <li>إذا كنت تتبع نظاماً غذائياً نباتياً صارماً</li>
                      <li>إذا كنت تعاني من مشاكل في الامتصاص</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <br />
            {/* FAQ Section */}
            <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
              أسئلة متكررة حول الفيتامينات
            </h2>
            <div className="info-sections-container">
              <div className="info-section">
                <div className="info-section-header">
                  <h3 style={{ fontSize: "16px" }}>
                    هل أحتاج لتناول مكملات الفيتامينات؟
                  </h3>
                </div>
                <div className="info-section-body">
                  <p style={{ lineHeight: "1.8" }}>
                    في معظم الحالات، يمكن الحصول على جميع الفيتامينات من{" "}
                    <strong>نظام غذائي متوازن ومتنوع</strong>. لكن هناك حالات قد
                    تستدعي تناول المكملات:
                  </p>
                  <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                    <strong>متى تكون المكملات ضرورية:</strong>
                  </h4>
                  <div
                    className="alert alert-success"
                    style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                  >
                    <ul style={{ marginTop: "10px" }}>
                      <li>
                        <strong>الحوامل والمرضعات:</strong> حمض الفوليك (400-800
                        ميكروغرام) والحديد
                      </li>
                      <li>
                        <strong>النباتيون:</strong> فيتامين B12 (لا يوجد في
                        النباتات)
                      </li>
                      <li>
                        <strong>كبار السن فوق 50:</strong> فيتامين D, B12,
                        الكالسيوم
                      </li>
                      <li>
                        <strong>الذين لا يتعرضون للشمس:</strong> فيتامين D
                      </li>
                      <li>
                        <strong>بعد جراحات السمنة:</strong> معظم الفيتامينات بسبب
                        سوء الامتصاص
                      </li>
                    </ul>
                  </div>
                  <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                    <strong>متى لا تحتاج للمكملات:</strong>
                  </h4>
                  <ul style={{ lineHeight: "1.8" }}>
                    <li>إذا كنت تتبع نظاماً غذائياً متوازناً</li>
                    <li>إذا كنت تتعرض للشمس بانتظام</li>
                    <li>إذا لم تكن لديك مشاكل في الامتصاص</li>
                    <li>إذا لم تظهر عليك أعراض نقص</li>
                  </ul>
                  <div
                    className="alert alert-warning mt-3"
                    style={{ lineHeight: "1.8" }}
                  >
                    <strong>⚠️ تحذير مهم:</strong> الإفراط في تناول الفيتامينات
                    (خاصة A, D, E, K) قد يكون ساماً. استشر طبيبك دائماً قبل
                    تناول أي مكملات.
                  </div>
                </div>
              </div>
              <div className="info-section">
                <div className="info-section-header">
                  <h3 style={{ fontSize: "16px" }}>
                    ما الفرق بين الفيتامينات الطبيعية والصناعية؟
                  </h3>
                </div>
                <div className="info-section-body">
                  <p style={{ lineHeight: "1.8" }}>
                    هناك فرق بين الفيتامينات من <strong>مصادر طبيعية</strong> و
                    <strong>المكملات الصناعية</strong>:
                  </p>
                  <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                    <strong>الفيتامينات الطبيعية (من الطعام):</strong>
                  </h4>
                  <div
                    className="alert alert-success"
                    style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                  >
                    <strong>المميزات:</strong>
                    <ul style={{ marginTop: "10px" }}>
                      <li>تأتي مع مغذيات أخرى مفيدة (ألياف، معادن، مضادات أكسدة)</li>
                      <li>أفضل امتصاصاً من قبل الجسم</li>
                      <li>أقل خطراً للجرعة الزائدة</li>
                      <li>تحتوي على مركبات نباتية مفيدة</li>
                    </ul>
                  </div>
                  <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                    <strong>المكملات الصناعية:</strong>
                  </h4>
                  <div
                    className="alert alert-info"
                    style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
                  >
                    <strong>المميزات:</strong>
                    <ul style={{ marginTop: "10px" }}>
                      <li>سهلة الاستخدام وموحدة الجرعة</li>
                      <li>مفيدة في حالات النقص الشديد</li>
                      <li>ضرورية لبعض الفئات (حوامل، نباتيين)</li>
                    </ul>
                    <br />
                    <strong>العيوب:</strong>
                    <ul>
                      <li>قد لا تُمتص جيداً مثل المصادر الطبيعية</li>
                      <li>خطر الجرعة الزائدة</li>
                      <li>لا تحتوي على مغذيات إضافية</li>
                      <li>قد تتفاعل مع بعض الأدوية</li>
                    </ul>
                  </div>
                  <div
                    className="alert alert-success mt-3"
                    style={{ lineHeight: "1.8" }}
                  >
                    <strong>✓ النصيحة الذهبية:</strong> الأولوية دائماً للحصول
                    على الفيتامينات من الطعام. المكملات تكون مساعدة فقط عند
                    الحاجة، وليست بديلاً عن التغذية الصحية.
                  </div>
                </div>
              </div>
              <div className="info-section">
                <div className="info-section-header">
                  <h3 style={{ fontSize: "16px" }}>
                    هل يمكن تناول جميع الفيتامينات معاً؟
                  </h3>
                </div>
                <div className="info-section-body">
                  <p style={{ lineHeight: "1.8" }}>
                    بعض الفيتامينات يمكن أن <strong>تتفاعل</strong> مع بعضها،
                    مما يؤثر على امتصاصها:
                  </p>
                  <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                    <strong>تفاعلات إيجابية (تناولها معاً):</strong>
                  </h4>
                  <div
                    className="alert alert-success"
                    style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                  >
                    <ul style={{ marginTop: "10px" }}>
                      <li>
                        <strong>فيتامين D + الكالسيوم:</strong> يحسن امتصاص
                        الكالسيوم
                      </li>
                      <li>
                        <strong>فيتامين C + الحديد:</strong> يزيد امتصاص الحديد
                      </li>
                      <li>
                        <strong>فيتامين K + فيتامين D:</strong> يعملان معاً لصحة
                        العظام
                      </li>
                      <li>
                        <strong>فيتامينات B المركب:</strong> تعمل معاً بشكل
                        تآزري
                      </li>
                    </ul>
                  </div>
                  <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                    <strong>تفاعلات سلبية (لا تناولها معاً):</strong>
                  </h4>
                  <div
                    className="alert alert-warning"
                    style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}
                  >
                    <ul style={{ marginTop: "10px" }}>
                      <li>
                        <strong>الكالسيوم + الحديد:</strong> يتنافسان على
                        الامتصاص (فاصل 2-3 ساعات)
                      </li>
                      <li>
                        <strong>الكالسيوم + الزنك:</strong> يقلل الكالسيوم من
                        امتصاص الزنك
                      </li>
                      <li>
                        <strong>فيتامين E + فيتامين K:</strong> جرعات عالية من E
                        قد تتداخل مع K
                      </li>
                    </ul>
                  </div>
                  <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                    <strong>أفضل أوقات تناول الفيتامينات:</strong>
                  </h4>
                  <ul style={{ lineHeight: "1.8" }}>
                    <li>
                      <strong>الصباح مع الإفطار:</strong> فيتامينات B المركب
                      (للطاقة)
                    </li>
                    <li>
                      <strong>مع الطعام:</strong> الفيتامينات الذائبة في الدهون
                      (A, D, E, K)
                    </li>
                    <li>
                      <strong>قبل النوم:</strong> الكالسيوم والمغنيسيوم (يساعدان
                      على الاسترخاء)
                    </li>
                    <li>
                      <strong>على معدة فارغة:</strong> الحديد (لأفضل امتصاص)
                    </li>
                  </ul>
                  <div
                    className="alert alert-info mt-3"
                    style={{ lineHeight: "1.8" }}
                  >
                    <strong>💡 نصيحة:</strong> إذا كنت تتناول عدة مكملات،
                    استشر الصيدلي أو الطبيب لمعرفة أفضل طريقة لتوزيعها خلال
                    اليوم.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
  );
};
export default VitaminDailyDoseCalculator;